module.exports = __webpack_public_path__ + "static/media/raceend.034ebcbe.gif";